export default {
  namespaced: true,
  state: {
    loginName: localStorage.getItem('loginName') || '',
    password: localStorage.getItem('password') || '',
    roleName: localStorage.getItem('roleName') || '',
    token: localStorage.getItem('token') || '',
    expireTime: localStorage.getItem('expireTime') || ''
  },
  getters: {},
  mutations: {
    DELETE_USERINFO(state) {
      state.loginName = ''
      state.roleName = ''
      state.token = ''
      localStorage.clear()
    },
    STORE_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    STORE_LOGINNAME(state, loginName) {
      state.loginName = loginName
      localStorage.setItem('loginName', loginName)
    },
    STORE_PASSWORD(state, password) {
      state.password = password
      localStorage.setItem('password', password)
    },
    STORE_TOKENEXPIRETIME(state, expireTime) {
      state.expireTime = expireTime
      localStorage.setItem('expireTime', expireTime)
    }
  },
  actions: {}
}
